import { HeaderBanner } from "@/components/Banner";
import { useLocalBackendUnavailableBanner } from "@/lib/backendSource";

export default function LocalBackendUnavailableBanner() {
  const { visible, detail, dismiss } = useLocalBackendUnavailableBanner();

  if (!visible) return null;

  return (
    <HeaderBanner
      variant="warn"
      inline
      description="Couldn't use the local backend. You're now using shared-dev."
      compactDescription="Using shared-dev"
      subText={detail ?? undefined}
      onClose={dismiss}
      testId="local-backend-unavailable-banner"
    />
  );
}
